import { useCallback, useMemo, useState } from 'react';

export const useIncrease = (): [number, () => void] => {
  const [num, setNum] = useState(0);
  const inc = useCallback(() => {
    setNum((n) => n + 1);
  }, []);
  return useMemo(() => [num, inc], [num, inc]);
};
